import React from 'react';
import config from 'config';

const t = {
  assigned: 'assigned driver: ',
};

const LinkToZendesk = ({ driverName, conversationId }) => {
  const zendeskUrlToConversation = `${config.ZENDESK_URL}/agent/tickets/${conversationId}`;

  return (
    <a
      href={zendeskUrlToConversation}
      target="_blank"
      rel="noopener noreferrer"
      className="driver__name--active"
    >
      {driverName}
    </a>
  );
};

const Header = ({ className, conversationId, driverName }) => {
  return (
    <div className={className}>
      <span className="driver">
        {t.assigned}
        {!!conversationId && (
          <LinkToZendesk driverName={driverName} conversationId={conversationId} />
        )}
        {!conversationId && <span className="driver__name--inactive">{driverName}</span>}
      </span>
    </div>
  );
};

export default Header;
